import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import "react-toastify/dist/ReactToastify.css";
import { FaInstagram, FaFacebookF, FaYoutube, FaWhatsapp } from "react-icons/fa";
import "./Contact.css"; // We'll style it here

const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const toastId = toast.loading("Sending your message...");

    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/contact`, form);
      toast.update(toastId, {
        render: res.data.message || "Message sent!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
        closeOnClick: true
      });
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      toast.update(toastId, {
        render: err.response?.data?.message || "Failed to send message.",
        type: "error",
        isLoading: false,
        autoClose: 3000,
        closeOnClick: true
      });
    }
  };

  return (
    <div className="contact-page">
      <ToastContainer position="top-right" />

      {/* Hero Section with Floating Leaves */}
      <div className="contact-hero">
        <motion.h1
          className="fw-bold text-white text-center"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          Get in Touch with <span className="highlight">RoupanNaturals</span>
        </motion.h1>
        <p className="text-white fw-5 text-center mt-2">
          We’d love to hear from you — whether it's a question, feedback, or just a hello!
        </p>
      </div>

      {/* Contact Info & Form */}
      <div className="container py-5">
        <div className="row gy-5 align-items-center">
          {/* Left: Info */}
          <div className="col-md-6" data-aos="fade-right">
            <h2 className="fw-bold mb-3">Reach Us</h2>
            <ul className="list-unstyled text-muted fs-5">
              <li>📞 +91 8700723140</li>
              <li>📧 roupannaturals@gmail.com</li>
              <li>📍 Sector 75, Noida, Uttar Pradesh 201307</li>
            </ul>

            {/* Social Links */}
            <div className="social-icons mt-4">
              <a href="https://www.instagram.com/roupannaturals?igsh=MWEzeGxqMWQ3aGhobA%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
              <a
                href="https://wa.me/918700723140?text=Hello%20Roupan%20Naturals!%20I%20have%20an%20inquiry."
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-btn"
              >
                <FaWhatsapp /> Chat on WhatsApp
              </a>
            </div>
          </div>

          {/* Right: Form */}
          <div className="col-md-6" data-aos="fade-left">
            <motion.div
              whileHover={{ scale: 1.02 }}
              transition={{ type: "spring", stiffness: 200 }}
              className="card shadow p-4 rounded-4"
            >
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label fw-bold">Full Name</label>
                  <input
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label fw-bold">Email Address</label>
                  <input
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    type="email"
                    className="form-control"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label fw-bold">Message</label>
                  <textarea
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    className="form-control"
                    rows="4"
                    required
                  />
                </div>
                <motion.button
                  type="submit"
                  className="btn btn-premium w-100 text-light"
                  style={{ backgroundColor: "black"  }}
                  whileHover={{ scale: 1.05, boxShadow: "0 8px 20px rgba(0,0,0,0.3)" }}
                  whileTap={{ scale: 0.95 }}
                >
                  Send Message
                </motion.button>
              </form>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
